import CryptoJS from 'crypto-js';

const PREFIX = 'ccms_';
const SECRET = import.meta.env.VITE_CLIENT_SECRET || 'dev-secret-key';

export function setEncryptedItem(key: string, value: unknown) {
  if (value === null || value === undefined) {
    localStorage.removeItem(PREFIX + key);
    return;
  }
  const json = JSON.stringify(value);
  const cipher = CryptoJS.AES.encrypt(json, SECRET).toString();
  localStorage.setItem(PREFIX + key, cipher);
}

export function getEncryptedItem<T>(key: string): T | null {
  const cipher = localStorage.getItem(PREFIX + key);
  if (!cipher) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET);
    const json = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(json) as T;
  } catch (error) {
    console.error('Failed to decrypt storage item', error);
    return null;
  }
}
